import { apiService, ApiResponse } from './api';
import { WorkoutSet, MemberExercise, Workout } from '../types/Workout';

export interface ShareTokenResponse {
  token: string;
}

export interface SharedWorkoutResponse {
  memberName: string;
  workouts: Workout[];
}

class WorkoutShareService {
  /** Generate share token for a member */
  async generateShareToken(memberId: number): Promise<ApiResponse<ShareTokenResponse>> {
    return apiService.get<ShareTokenResponse>(`/api/workouts/member/${memberId}/share`);
  }

  /** Get shared workout plan by token */
  async getSharedWorkout(token: string): Promise<ApiResponse<SharedWorkoutResponse>> {
    return apiService.get<SharedWorkoutResponse>(`/api/workouts/shared/${token}`);
  }
}

export const workoutShareService = new WorkoutShareService(); 